import React from "react";
import {Table, Tooltip} from "antd";
import {sumBy} from "lodash";
import {StringBuilder} from "../AppUtils.js";
import {FoodRequestsShortIdToName} from "../marketplace/ProductsFilterModal/consts.jsx";
import {FoodRequestToIcon} from "../marketplace/OrderFormModularProductsPanel/consts.jsx";

const columns = [
    {
        title: "תיאור",
        dataIndex: "desc"
    },
    {
        title: "כמות פריטים",
        className: "amount",
        dataIndex: "amount"
    },
    {
        title: "מחיר",
        dataIndex: "pricePerUnit"
    },
    {
        title: "סה״כ",
        dataIndex: "totalPrice"
    }
];

export const generateTableContent = bidInfo => {
    const dataSource =
        bidInfo?.package?.options?.map((item, index) => ({
            key: index,
            desc: (
                <div>
                    <div className="order-information-card-details-table-title">
                        <b>{item.name}</b>
                        {(item?.foodRequests ?? []).map((foodOption, index) => {
                            return (
                                <Tooltip key={index} title={FoodRequestsShortIdToName[foodOption]}>
                                    <img
                                        key={index}
                                        className="sub-product-food-request-image"
                                        src={FoodRequestToIcon[foodOption]}
                                        alt={foodOption}
                                        style={{marginRight: 5}}
                                    />
                                </Tooltip>
                            );
                        })}
                    </div>
                    {item.sku && (
                        <div className="order-information-card-details-table-desc">
                            {new StringBuilder().append(`מק"ט: `).append(item.sku).toString()}
                        </div>
                    )}
                </div>
            ),
            amount: item.amount || 0,
            pricePerUnit: new StringBuilder()
                .append(item.price || 0)
                .append("₪")
                .toString(),
            totalPrice: new StringBuilder()
                .append((item.price || 0) * (item.amount || 0))
                .append("₪")
                .toString()
        })) || [];

    return {
        summary: () => {
            const totalAmount = sumBy(bidInfo?.package?.options, item => item.amount || 0);
            const totalPrice = sumBy(bidInfo?.package?.options, item => (item.price || 0) * (item.amount || 0));

            return (
                <>
                    <Table.Summary.Row className="">
                        <Table.Summary.Cell index={0}>{"סה״כ כולל מע״מ"}</Table.Summary.Cell>
                        <Table.Summary.Cell index={1}>{totalAmount}</Table.Summary.Cell>
                        <Table.Summary.Cell index={2}>{""}</Table.Summary.Cell>
                        <Table.Summary.Cell index={3}>
                            {new StringBuilder().append(totalPrice.toFixed(2)).append("₪").toString()}
                        </Table.Summary.Cell>
                    </Table.Summary.Row>
                </>
            );
        },
        dataSource,
        columns
    };
};
